import { cn, Gutter, StateIcon, type States } from "@qw/ui";
import type { ComponentProps, FC } from "react";
export const Row: FC<ComponentProps<"div"> & { button?: React.ReactNode; href?: string; state: States }> = ({
  button,
  children,
  className,
  href,
  state,
  ...props
}) => (
  <div
    className={cn(
      "group bg-muted/50 border border-border/60 flex gap-3 items-start p-3 rounded text-xs transition-colors hover:bg-muted/70",
      className
    )}
    {...props}
  >
    <a href={href} target="_blank" className="flex flex-auto gap-3 items-start truncate" rel="noreferrer">
      <Gutter className="flex-none mt-0.5 relative w-4">
        <StateIcon state={state} />
      </Gutter>
      {children}
    </a>
    <div className="-mr-1 -my-1 flex items-center">{button}</div>
  </div>
);
